@import { icons, type IconName } from "@source-crafter/xzor-ui"

@code {
  name: IconName = "dots";
}

<svg class="xz-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="@icons[name]" /></svg>
